import React from 'react';
import { Card, CardContent } from '@/components/ui/Card';
import { classNames, formatPercent, getComplianceColor } from '@/lib/utils';

interface ComplianceCardProps {
    title: string;
    value: number;
    subtitle?: string;
    icon?: React.ReactNode;
    className?: string;
}

export function ComplianceCard({ title, value, subtitle, icon, className }: ComplianceCardProps) {
    const color = getComplianceColor(value);

    const colorClasses = {
        success: 'text-status-success bg-status-success/10',
        warning: 'text-status-warning bg-status-warning/10',
        danger: 'text-status-danger bg-status-danger/10',
    };

    return (
        <Card className={className}>
            <CardContent>
                <div className="flex items-start justify-between">
                    <div>
                        <p className="text-sm text-content-muted mb-1">{title}</p>
                        <p className={classNames(
                            'text-4xl font-bold',
                            color === 'success' ? 'text-status-success' :
                                color === 'warning' ? 'text-status-warning' :
                                    'text-status-danger'
                        )}>
                            {formatPercent(value, 0)}
                        </p>
                        {subtitle && (
                            <p className="text-sm text-content-muted mt-1">{subtitle}</p>
                        )}
                    </div>
                    {icon && (
                        <div className={classNames(
                            'w-12 h-12 rounded-full flex items-center justify-center',
                            colorClasses[color]
                        )}>
                            {icon}
                        </div>
                    )}
                </div>

                {/* Progress bar */}
                <div className="mt-4 w-full bg-gray-200 rounded-full h-2">
                    <div
                        className={classNames(
                            'h-2 rounded-full transition-all duration-500',
                            color === 'success' ? 'bg-status-success' :
                                color === 'warning' ? 'bg-status-warning' :
                                    'bg-status-danger'
                        )}
                        style={{ width: `${Math.min(value, 100)}%` }}
                    />
                </div>
            </CardContent>
        </Card>
    );
}

export default ComplianceCard;
